"use client";

import React, { useState } from "react";

import styles from "./hamburger.module.css";
import Social from "../../pages/social";

const Hamburger = () => {
    const [isOpen, setIsOpen] = useState(false);

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    return (
        <div className={styles.hamburgerContainer}>
            <h6 
                className={`${styles.hamburger} ${isOpen ? styles.hamburgerOpen : ''}`}
                onClick={toggleMenu}
                aria-label="Toggle navigation menu"
            >
                {isOpen ? 'Lat aftur' : 'Valmynd'}
            </h6>

            {/* Mobile navigation overlay */}
            <div className={`${styles.mobileNav} ${isOpen ? styles.mobileNavOpen : ''}`}>
                <ul>
                    {/*<a href="/sukklarir"><li>Til súkklarar og gongufólk</li></a>*/}
                    {/*<a href="/felog"><li>Til feløg og myndugleikar</li></a>*/}
                    <a href="/limir"><li>Vís undirtøku</li></a>
                    <a href="/um"><li>Um felagið</li></a>
                </ul>
                <Social />
            </div>

            <div onClick={toggleMenu} className={`${styles.mobileNavBackdrop} ${isOpen ? styles.mobileNavBackdropOpen : ''}`}></div>

        </div>
    );
};

export default Hamburger;